export { shellWget } from './wget.js';
